import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.75669 9.38144C4.30967 7.45296 5.45898 5.74904 7.03989 4.5139C8.6208 3.27876 10.5521 2.5758 12.5571 2.50579C14.5621 2.43577 16.5378 3.00229 18.201 4.12414C19.8642 5.246 21.1296 6.8656 21.8158 8.75081",
      stroke: "#303333",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.6414 15.6931C20.9268 17.3868 19.7361 18.8368 18.2137 19.8673C16.6913 20.8977 14.9027 21.4643 13.0647 21.4984C11.2267 21.5324 9.41828 21.0325 7.85877 20.0592C6.29927 19.0858 5.05565 17.681 4.27875 16.0149",
      stroke: "#303333",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.60065 15.0242L4.1465 15.3157L2.49244 19.5527",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.0742 9.36035L21.6999 9.34898L23.2792 5.13764",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }